import sortBy from 'lodash/sortBy';

export const sortData = (sources, sortStatus) => {
  let sorted;

  if (sortStatus.columnAccessor === 'createdAt' || sortStatus.columnAccessor === 'updatedAt') {
    sorted = sortBy(sources, (record) => new Date(record[sortStatus.columnAccessor]));
  } else {
    sorted = sortBy(sources, sortStatus.columnAccessor);
  }

  return sortStatus.direction === 'desc' ? sorted.reverse() : sorted;
};

export const filterData = (data, filters, columns = []) => data.filter(
  (item) => Object.entries(filters).every(([key, value]) => {
    if (value === '' || value === null || value === undefined) return true;
    if (Array.isArray(value)) {
      if (!value[0] && !value[1]) return true;
      const itemDate = new Date(item[key]);
      return (!value[0] || itemDate >= new Date(value[0]))
        && (!value[1] || itemDate <= new Date(value[1]));
    }

    // Check if this column uses numberInput filter type
    const column = columns.find((col) => col.accessor === key);
    if (column?.filterType === 'numberInput') {
      // For number input, use exact match comparison
      const itemValue = Number(item[key]);
      const filterValue = Number(value);
      return !Number.isNaN(itemValue) && !Number.isNaN(filterValue) && itemValue === filterValue;
    }

    return (item[key] ?? '').toString().toLowerCase().includes(value.toString().toLowerCase());
  }),
);

export const paginateData = (sources, page, recordsPerPage) => sources.slice(
  (page - 1) * recordsPerPage,
  page * recordsPerPage,
);
